import { render, staticRenderFns } from "./Simple.vue?vue&type=template&id=6f131a32&"
import script from "./Simple.vue?vue&type=script&lang=ts&"
export * from "./Simple.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MainTitle: require('/builds/simistry/gm/graduatemastery.com-nuxt/site/components/MainTitle.vue').default,PageContent: require('/builds/simistry/gm/graduatemastery.com-nuxt/site/components/PageContent.vue').default})
